import { useEffect } from 'react';

import { useConfiguration } from '../../../contexts/ConfigurationContext';

interface UseProcessMediaDataProps {
	mediaId?: string;
	accountId: string;
	playlistId?: string;
}

const useProcessMediaData = ({ mediaId, accountId, playlistId }: UseProcessMediaDataProps) => {
	const { setAccountId, setCurrentMediaId, setCurrentPlaylistId, setMediaType } = useConfiguration();

	useEffect(() => {
		accountId && setAccountId(accountId);
		playlistId && setCurrentPlaylistId(playlistId);
		mediaId && setCurrentMediaId(mediaId);
		(mediaId || playlistId) && setMediaType('video');
	}, [mediaId, accountId, playlistId]);

	return { mediaId };
};

export default useProcessMediaData;
